export const metaTitlesEn = {
    homePageMetaTitle: "AI, Blockchain & Technology Services | Bitsclan IT Solutions",
    industyPageTitle: "Expert IT Solutions Tailored for Each Industry | Bitsclan",
    engagementModelPageTitle: "Flexible Engagement Models for IT Solutions | Bitsclan IT Solutions",
    lifeAtBitsclanTitle: "Careers at Bitsclan | Explore Opportunities & Culture",
    blogsTitle: "Explore Our Blog | Latest in AI, Blockchain & Tech by Bitsclan",
    portFolioTitle: "Portfolio | Explore Bitsclan's Successful Software Projects",
    contactUsTitle: "Get in Touch for Expert Services | Bitsclan IT Solutions",

    aiPageTitle: "AI Development Services | Custom AI/ML Solutions | Bitsclan",
    webAppDevTitle: "Bespoke Web App Development Services | Bitsclan IT Solutions",
    cyberSecPageTitle: "Protect Your Business with Cybersecurity Services | Bitsclan",
    customSoftwareTitle: "Custom Software Development Company | Bitsclan IT Solutions",
    blockChainTitle: "Top Blockchain Development Services | Bitsclan IT Solutions",
    mobileAppDevTitle: "Mobile App Development Services | Custom iOS & android Solutions",
    dataAnalyticsTitle: "Data Analytics Services | Data Science | Bitsclan IT Solutions",
    devOpsMetaTitle: "DevOps Services & Solutions | Bitsclan IT Solutions",
    qaMetaTitle: "Software Quality Assurance Services | QA Testing Company",

    hireRoRTitle: "Hire Ruby on Rails Programmers | RoR Development Services",
    hireDjangoTitle: "Hire Django Developers | Django Development Services",
    hirePythonTitle: "Hire Python Developers | Dedicated Python Programmers for Hire",
    hireGolangTitle: "Hire Golang Developers | Golang Development Services",
    hireJavascriptTitle: "Hire JavaScript Developers | JavaScript Development Services",
    hireReactTitle: "Hire ReactJS & Native Developers | Dedicated React Engineers",
    hireFlutterTitle: "Hire Flutter AI App Developers | AI Powered Mobile Experts Bitsclan",
    hireAndroidTitle: "Hire android App Developer | Top Rated Mobile App Development Company",
    hireAngularTitle: "Hire Angular Developers | Angular Development Services",
    hireMernTitle: "Hire MERN Stack Developers | Full-Stack Web Development",
    hireNodeTitle: "Hire Node Js Developers | Node Development Services",

    healthcareTitle: "Healthcare Software Development Services | Secure & Scalable Solutions",
    ecommerceTitle: "Custom Retail Software Development Services | Drive Retail Success",
    fintechTitle: "Fintech Software Development Services | Next-Gen Financial Solution",
    edtechTitle: "Education Software Development Services | Smart Learning Solutions",
    realEstateTitle: "Real Estate Software Development | Transform Property Management",
    insuranceTitle: "Insurance Software Development Services | Reliable Digital Solutions",
    logisticsTitle: "Logistics Software Development Services | Streamline Supply Chain Operations",
    automotiveTitle: "Automotive Software Development Services | Drive Innovation & Efficiency",
    gamingTitle: "Game Development Services | Immersive & Scalable Gaming Solutions",
    entertainmentTitle: "Entertainment Software Development Services | Engage Audiences with Innovative Solutions",
    socialMediaTitle: "Social Networking App Development Services | Build Engaging Digital Communities",
    telecomTitle: "Telecom Software Development Services | Empower Connectivity & Innovation",
    energyTitle: "Energy Software Development Services | Powering Digital Transformation",
    agricultureTitle: "Agriculture Software Development Services | Cultivating Smart Farming Solutions"
};